import { useState } from 'react'
import { Modal } from 'components'
import toast from 'react-hot-toast'
import { lang } from 'config'
import { useAuth } from "contexts/auth-context"
import { executeAPI } from "repositories/db-repository"
import { useSWRConfig } from "swr"
import { useNavigate } from "react-router-dom"

const Content = ({ data, success }) => {
  const { user } = useAuth()
  const [errors, setErrors] = useState({})
  const { cache } = useSWRConfig()
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault()

    const onSuccess = (result, message) => {
      cache.clear()
      navigate({ pathname: '/return' })
      if (data?.message) {
        toast.success(data?.message, { id: "submit" })
      } else {
        toast.success("Return berhasil dicancel!", { id: "submit" })
      }
      success?.()
    }

    const onError = (message) => {
      toast.error("onError: " + message, { id: "submit" })
    }

    if (data?.id) {
      toast.loading("Loading", { id: "submit" })

      // gunakan endpoint update_return_header sesuai API yang sudah kita buat
      executeAPI(
        `${process.env.REACT_APP_REMAX_PS_API_URL}`,
        "update_return_header",
        {
          id: data?.id,
          origin: data?.origin ?? 'RT',
          latest_flow_detail_id: "RETURN_CANCELLED",
          flow_detail_id: "RETURN_CANCELLED",
          return_type: data?.return_type,
          warehouse_id: data?.warehouse_id,
          warehouse_name: data?.warehouse_name,
          warehouse_address: data?.warehouse_address,
          supplier_id: data?.supplier_id,
          supplier_name: data?.supplier_name,
          record_status: "U",
          updated_by: user?.name
        },
        onSuccess,
        onError
      )
    } else {
      setErrors({})
    }
  }

  // gunakan id sebagai nomor return yang ditampilkan (fallback dari purchase_number)
  const displayNumber = data?.return_number || data?.purchase_number || data?.id

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-8">
      {lang.are_you_sure_you_want_to_cancel}{" "}
      <span className="inline-flex px-3 py-1 text-sm font-medium rounded-xl bg-neutral-200 text-neutral-600">
        {displayNumber}
      </span>{" "}
      ?
      <div className="text-xs">
        <button type="submit" className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
          <span>{lang.yes}</span>
        </button>
      </div>
    </form>
  )
}

const Delete = ({ data, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const handleSuccess = () => {
    closeModal()
    onSuccess?.()
  }

  // tentukan status saat ini (support berbagai field)
  const statusNow = data?.status || data?.latest_flow_detail_id || data?.flow_detail_id
  const canCancel = statusNow === "RETURN_DRAFT"

  return (
    <>
      <button
        disabled={!canCancel}
        onClick={canCancel ? openModal : () => {}}
        className={`${!canCancel ? 'opacity-50 bg-red-900' : 'bg-red-800'} inline-flex items-center p-1 text-white transition rounded-full active:hover:scale-90`}
        title="Cancel Return"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <line x1={4} y1={7} x2={20} y2={7}></line>
          <line x1={10} y1={11} x2={10} y2={17}></line>
          <line x1={14} y1={11} x2={14} y2={17}></line>
          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
        </svg>
      </button>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={`${lang.cancel} ${lang.return}`}
        content={<Content data={data} success={handleSuccess} />}
      />
    </>
  )
}

export default Delete
